import React from 'react';
import { Typography } from 'antd';
import type { SimplifiedPendingOrder } from '@/services/PendingOrdersService';

const { Text } = Typography;

interface Props {
  order: SimplifiedPendingOrder | null;
}

const OrderEmailContent: React.FC<Props> = ({ order }) => {
  console.log(order);
  
  if (!order) return null;

  const totalItems = (order.references || []).reduce(
    (sumReferences, reference) =>
      sumReferences + (reference.items || []).reduce((sumItems, item) => sumItems + (item.quantity_pending || 0), 0),
    0,
  );

  const orderCode = `${String(order.orderNumber).padStart(7, '0')}`;
  const clientName = order.client_name || order.client || '';
  const sellerName = order.seller_name || '';
  const deliveryDate = order.delivery_date || '';
  const totalValue = order.total_value !== null && order.total_value !== undefined ? String(order.total_value) : '';

  const summary = [
    { key: 'pedido', label: 'Pedido', value: orderCode },
    { key: 'cliente', label: 'Cliente', value: clientName },
    { key: 'vendedor', label: 'Vendedor', value: sellerName },
    { key: 'entrega', label: 'Entrega', value: deliveryDate },
    { key: 'items', label: 'Items', value: totalItems },
    { key: 'total', label: 'Total', value: totalValue },
  ];

  return (
    <div style={{ width: '100%', border: '1px solid #000', background: '#fff' }}>
      <div style={{ borderBottom: '1px solid #000', padding: '8px 10px' }}>
        <Text style={{ display: 'block', fontSize: 11, color: '#000' }}>CRM</Text>
        <Text style={{ display: 'block', fontSize: 18, fontWeight: 700, color: '#000' }}>Pedido en PDF</Text>
      </div>

      <div style={{ padding: 10 }}>
        <Text style={{ display: 'block', marginBottom: 10, color: '#000' }}>Adjunto encontraras el PDF del pedido.</Text>

        <div style={{ border: '1px solid #000' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
            <tbody>
              {summary.map((entry) => (
                <tr key={entry.key}>
                  <td style={{ borderRight: '1px solid #000', borderBottom: '1px solid #000', width: 130, padding: '8px 10px', fontSize: 12, color: '#000', verticalAlign: 'top' }}>
                    {entry.label}
                  </td>
                  <td style={{ borderBottom: '1px solid #000', padding: '8px 10px', fontSize: 13, fontWeight: 600, color: '#000', wordBreak: 'break-word' }}>
                    {entry.value}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <Text style={{ display: 'block', marginTop: 10, fontSize: 12, color: '#000' }}>Este correo fue enviado desde el CRM.</Text>
      </div>
    </div>
  );
};

export default OrderEmailContent;
